import "./style.scss";
import $ from "jquery";

$(function () {
    const state = {
        $inlineNewsletter: null,
        halfHeight: 0,
        screenHeight: $(window).height(),
        screenHalfHeight: 0.5 * $(window).height(),
        maxOpacity: 0.8,
        currentViewport: $(window).width() >= 990 ? 'desktop' : 'mobile'
    };

    const getViewport = () => $(window).width() >= 990 ? 'desktop' : 'mobile';

    const updateOpacityOnScroll = () => {
        if (!state.$inlineNewsletter) {
            return;
        }

        const scrollTop = $(window).scrollTop();
        const offsetTop = state.$inlineNewsletter.offset().top;

        if (
            scrollTop > offsetTop - state.screenHeight &&
            scrollTop < offsetTop
        ) {
            let offset = scrollTop - offsetTop + state.screenHalfHeight + state.halfHeight;

            let opacity = 1 - Math.abs(offset) / state.screenHalfHeight;
            if (opacity >= state.maxOpacity) {
                opacity = state.maxOpacity;
            }

            state.$inlineNewsletter
                .addClass('wp-block-ow-newsletter--with-spotlight')
                .css('--opacity', opacity);
        } else {
            state.$inlineNewsletter
                .removeClass('wp-block-ow-newsletter--with-spotlight')
                .css('--opacity', 0);
        }
    };

    const onResize = () => {
        const newViewport = getViewport();

        if (newViewport !== state.currentViewport) {
            state.currentViewport = newViewport;

            if (newViewport === 'mobile') {
                $(window).off('scroll', updateOpacityOnScroll);
                state.$inlineNewsletter
                    .removeClass('wp-block-ow-newsletter--visible')
                    .css('--opacity', 0);
            } else {
                $(window).on('scroll', updateOpacityOnScroll);
            }
        }
    };

    const init = () => {
        state.$inlineNewsletter = $('.wp-block-ow-newsletter.add-spotlight').first();

        if (state.$inlineNewsletter.length && state.currentViewport !== 'mobile') {
            state.halfHeight = 0.5 * state.$inlineNewsletter.outerHeight();
            $(window).on('scroll', updateOpacityOnScroll);
        }

        // Listen for resize event or trigger manually
        $(window).on('resize', onResize);
    };

    $(document).ready(init);
});